import React from 'react';

export const FunctionBuilder = (props: {
  children: () => React.ReactElement;
}) => {
  return props.children();
};
